import {
  Component,
  Input,
  ViewChild
} from '@angular/core';

import { ModalComponent, TrapFocusComponent } from 'remarketing-ui-components-lib';

import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'app-address-changed-modal',
    templateUrl: './address-changed-modal.component.html',
    styleUrls: ['./address-changed-modal.component.scss'],
    imports: [TranslocoDirective, TrapFocusComponent, ModalComponent]
})
export class AddressChangedModalComponent {
  @Input() modalId: string;
  @ViewChild(ModalComponent) modal: ModalComponent;
  public variant: string;

  show(variant: string) {
    this.variant = variant;
    this.modal.show();
  }

  close() {
    this.modal.close();
  }
}
